<template>
    <div class="entities">
        <nav class="top-navbar">
            <div class="title">
                <div class="title-inner">
                    <span class="title-inner-name" v-i18n="'MN_SEASONS'" />
                </div>
            </div>
            <div class="icon-right">
                <router-link to="/seasons/add" class="bordered-icon btn-add-entity"  v-if="$hisport.permissions.isAdmin()">
                <font-awesome-icon :icon="['fas','plus']"/>
                </router-link>
                <a href="javascript: void 0" @click="toggleFilters" class="bordered-icon btn-filter">
                <font-awesome-icon :icon="['fas','filter']"/>
                </a>
            </div>
        </nav>
        <entity-table   :entities="entities"
                        :columns="columns"
                        :loadItems="loadItems">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'start_at' || props.column.field == 'end_at'">
                    <router-link :to="'/seasons/' + props.formattedRow.id">
                        {{props.formattedRow[props.column.field] | moment('DD MMMM YYYY')}}
                    </router-link>
                </span>
                <span v-else-if="props.column.field == 'id_sport'">
                    <router-link :to="'/sports/' + props.formattedRow[props.column.field]" v-if="props.formattedRow[props.column.field]">
                        <span v-i18n="$hisport.getSportName(props.formattedRow[props.column.field])"></span>
                    </router-link>
                </span>
                <span v-else>
                    <router-link :to="'/seasons/' + props.formattedRow.id">
                        {{props.formattedRow[props.column.field]}}
                    </router-link>
                </span>
            </template>
            
        </entity-table>
    </div>
</template>
<script>
import entityTable from "../_components/entity_table"
// import contacts from "../_components/contacts"
export default {
    title: "SEASONS",
    components: {
        // contacts,
        entityTable
    },
    data(){
        return {
            entities: null,
            columns: [        
                {   field: "id",       hidden: true},  
                {   field: "name",     
                    label: this.$options.filters.i18n("ENTITY_NAME"), 
                    filterOptions: {
                        enabled: false, 
                        trigger: 'enter'
                    },
                    sortable: true
                },
                {   field: "id_sport", label: this.$options.filters.i18n("SPORT"), sortable: true },      
                {   field: "start_at", label: this.$options.filters.i18n("START_AT"), sortable: true },      
                {   field: "end_at", label: this.$options.filters.i18n("END_AT"), sortable: true },             
                {   field: "events.length", 
                    label: this.$options.filters.i18n("EVENTS")}
            ]
        }
    },
    methods: {
        toggleFilters(){
            this.columns.forEach(function(col){
                if(col.filterOptions){
                    col.filterOptions.enabled = !col.filterOptions.enabled;
                }
            })
        },
        loadItems(options) {
            var self = this;
            if(typeof options == "object")
                options = {
                    page_index: options.page, 
                    page_size: options.perPage,
                    sort: options.sort,
                    column_filters: options.columnFilters
                }
            this.$hisport.datacontext.season.getAll(options)
                .then(function(entities){
                    self.entities = entities;
                    self.$store.dispatch("setLoading", false);
                });
        }
    }
}
</script>